/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'


class MainItemBlock extends React.Component {
    static defaultProps = {
        blockContent: {
            img: '',
            text: '',
            method: () => {},
            color: 'rgba(0,0,0,0)',
            iconText: ''
        },
        nopic: false,
        hasBanner: false,
    };

    render() {
        const {blockContent, nopic, hasBanner, bannerText} = this.props;

        return (
            <div className="mainpage-block" onClick={blockContent.method}>
                {hasBanner &&
                <div className="mainpage-block-banner">
                    <span>{bannerText}</span>
                </div>
                }
                {nopic &&
                <div className="mainpage-block-img" style={{backgroundColor: blockContent.color}}>
                    {blockContent.iconText}
                </div>
                }
                {!nopic &&
                <div className="mainpage-block-img">
                    <img src={blockContent.img} alt=""/>
                </div>
                }
                <div className="mainpage-block-text">
                    {blockContent.text}
                </div>
            </div>
        )
    }
}

export default MainItemBlock


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainItemBlock.js